import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const createContactSchema = z.object({
    firstName: z.string().trim().min(1).max(100),
    lastName: z.string().trim().min(1).max(100),
    email: z.string().trim().toLowerCase().email().optional(),
    phone: z.string().trim().max(40).optional(),
    mobile: z.string().trim().max(40).optional(),
    jobTitle: z.string().trim().max(150).optional(),
    department: z.string().trim().max(150).optional(),
    ownerId: z.string().uuid().optional(),
    primaryCompanyId: z.string().uuid().optional(),
    customFields: z.record(z.string(), z.unknown()).default({}),
});
export const updateContactSchema = createContactSchema.partial().extend({
    version: z.number().int().nonnegative(),
});
export const listContactsQuerySchema = paginationQuerySchema.extend({
    ownerId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
    lifecycleStage: z.enum(['lead', 'customer']).optional(),
    createdAfter: z.string().datetime().optional(),
});
/** The Contacts list's 4 built-in tabs (design/orion-crm-design/
 * rendered-html/Contacts.html) — real counts. */
export const contactCountsResponseSchema = z.object({
    all: z.number().int(),
    mine: z.number().int(),
    customers: z.number().int(),
    recentlyAdded: z.number().int(),
});
export const contactResponseSchema = z.object({
    id: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string(),
    fullName: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    mobile: z.string().nullable(),
    jobTitle: z.string().nullable(),
    department: z.string().nullable(),
    lifecycleStage: z.string(),
    owner: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
    primaryCompany: z.object({ id: z.string().uuid(), name: z.string() }).nullable(),
    tags: z.array(z.object({ id: z.string().uuid(), name: z.string(), color: z.string() })),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    version: z.number().int(),
});
//# sourceMappingURL=schemas.js.map